const actions = {
  FETCH_ACCOUNTS: 'investordashboard/FETCH_ACCOUNTS',
  FETCH_ACCOUNTS_SUCCESS: 'investordashboard/FETCH_ACCOUNTS_SUCCESS',
  SET_LOADING_STATE: 'investordashboard/SET_LOADING_STATE',
  FETCH_FUND_DATA: 'investordashboard/FETCH_FUND_DATA',
  FETCH_FUND_DATA_SUCCESS: 'investordashboard/FETCH_FUND_DATA_SUCCESS',
}

export default actions
